module.exports = __webpack_public_path__ + "img/gartentor_1.baee0d6f.webp";